// import components
import { styled } from '@mui/material';
import { DesktopDateRangePicker } from '@mui/x-date-pickers-pro';

export const StyledDateRangePicker = styled(DesktopDateRangePicker)(() => ({
  '& button:disabled': {
    border: 'none',
    backgroundImage: 'none'
  }
}));
